import React, { useEffect as uEffect } from 'react'

import { useState as uState } from "react";
import "../chart.scss";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

export default function ordersAreaChart({ aspect, title }) {
    const [monthOrders, setMonthOrders] = uState("")
    const [monthOrders2, setMonthOrders2] = uState("");
    const [monthOrders3, setMonthOrders3] = uState("");
    const [monthOrders4, setMonthOrders4] = uState("");
    const [monthOrders5, setMonthOrders5] = uState("");
    const [monthOrders6, setMonthOrders6] = uState("");


    var currentDate = new Date(); // get the current date

    var dates = [];

    for (var i = 0; i < 6; i++) {
        // loop through the previous six months
        var previousMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - i
        ); // get the date object for the previous month
        var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        var previousMonthName = monthNames[previousMonth.getMonth()]; // get the name of the previous month
        var previousMonthYear = previousMonth.getFullYear(); // get the year of the previous month

        // if the previous month is in the previous year, subtract 1 from the year
        if (previousMonth.getMonth() > currentDate.getMonth()) {
            previousMonthYear -= 0;
        }

        var obj = { name: previousMonthName, Year: previousMonthYear }; // create an object with the name of the month and the year
        dates.push(obj); // add the object to the data array
    }

    uEffect(() => {
        fetch("http://localhost:8000/order/ordrsMonth", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((response) => response.json())
            .then((data) => setMonthOrders(data)
            );
        fetch("http://localhost:8000/order/ordrsMonth2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((response) => response.json())
            .then((data) => setMonthOrders2(data));
        fetch("http://localhost:8000/order/ordrsMonth3", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((response) => response.json())
            .then((data) => setMonthOrders3(data));

        fetch("http://localhost:8000/order/ordrsMonth4", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((response) => response.json())
            .then((data) => setMonthOrders4(data));
        fetch("http://localhost:8000/order/ordrsMonth5", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((response) => response.json())
            .then((data) => setMonthOrders5(data));
        fetch("http://localhost:8000/order/ordrsMonth6", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then((response) => response.json())
            .then((data) => setMonthOrders6(data));
    },[])

    const fetchData = [
        { name: dates[5].name, Year: dates[5].Year, Total: monthOrders6 },
        { name: dates[4].name, Year: dates[4].Year, Total: monthOrders5 },
        { name: dates[3].name, Year: dates[3].Year, Total: monthOrders4 },
        { name: dates[2].name, Year: dates[2].Year, Total: monthOrders3 },
        { name: dates[1].name, Year: dates[1].Year, Total: monthOrders2 },
        { name: dates[0].name, Year: dates[0].Year, Total: monthOrders },
    ];

  return (
      <>
      

          <div className="chart">
              <div className="title">{title}</div>
              <ResponsiveContainer width="100%" aspect={aspect}>
                  <AreaChart
                      width={730}
                      height={250}
                      data={fetchData}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                      <defs>
                          <linearGradient id="Total" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                              <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                          </linearGradient>
                      </defs>
                      <XAxis dataKey="name" stroke="gray" />
                      <YAxis dataKey="Total" stroke="gray" />
                      <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
                      <Tooltip />
                      <Area
                          type="monotone"
                          dataKey="Total"
                          stroke="#8884d8"
                          fillOpacity={1}
                          fill="url(#Total)"
                      />
                  </AreaChart>
              </ResponsiveContainer>
          </div>
      
      
      
      </>
  )
}
